// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_plW5Q){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_4KH0p .dualColumn_2cGX6{display:flex;align-content:space-between}.nsAddressForm_4KH0p .dualColumn_2cGX6 .firstCol_14GVh{margin-right:20px}.optional_1xizC{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_plW5Q",
	"nsAddressForm": "nsAddressForm_4KH0p",
	"dualColumn": "dualColumn_2cGX6",
	"firstCol": "firstCol_14GVh",
	"optional": "optional_1xizC"
};
module.exports = exports;
